import { Component, Input, Inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Order } from '../../interfaces/orders/order';
import { OrderMessage } from '../../interfaces/order-messages/order-messasge';
import { OrderMessagesRepositoryService } from '../../services/order-messages/order-messages-repository.service';
import { OrderMessageForUpdate } from '../../interfaces/order-messages/order-message-for-update';
import { OrderMessageForCreation } from '../../interfaces/order-messages/order-message-for-creation';

@Component({
  selector: 'lib-order-messages',
  templateUrl: './order-messages.component.html',
  styleUrls: ['./order-messages.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OrderMessagesComponent {
  isSaving: boolean = false;
  order: Order;
  isCustomer: boolean;
  orderMessages: OrderMessage[] = [];
  dataSource = new MatTableDataSource<OrderMessage>([]);

  // The table is behind an @if, so MatSort appears/disappears with the message
  // list. A setter re-attaches it whenever the table is (re)created.
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    if (sort) {
      this.dataSource.sort = sort;
    }
  }
  // validState: boolean = false;
  newMessage: OrderMessageForCreation = {
    message: "",
    isCustomerVisible: true,
    isInternalToCustomer: false,
    isReadByAdmin: false
  };

  displayColumns: string[] = [
    'message',
    'added',
    'customerRead'
  ];

  customerDisplayedColumns = [
    ...this.displayColumns,
  ];

  adminisplayedColumns = [
    ...this.displayColumns,
    'adminRead',
    'customerVisible',
    'delete'
  ];

  constructor(protected orderMessageService: OrderMessagesRepositoryService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any) {
    this.order = dialogData.order;
    this.isCustomer = dialogData.customer;

    // this.validState = !this.isCustomer;

    if (this.isCustomer) {
      //Only Customer Visible Items
      this.orderMessages = this.order.orderMessages?.filter((u) => u.isCustomerVisible) || [];
    }
    else {
      this.orderMessages = this.order.orderMessages?.filter((u) => !u.isInternalToCustomer) || [];
    }

    // 'added' arrives from the API as an ISO string, so compare it as a timestamp
    // rather than letting the default accessor compare it as text.
    this.dataSource.sortingDataAccessor = (message, columnID) =>
      columnID === 'added'
        ? new Date(message.added).getTime()
        : (message as any)[columnID];

    this.dataSource.data = this.orderMessages;
  }

  updateOrderMessage(orderMessage: OrderMessage) {
    this.orderMessageService.updateOrderMessage(orderMessage.orderID, orderMessage.id, orderMessage as OrderMessageForUpdate)
      .subscribe(() => {
        this.resetOrderMessages();
      });
  }

  deleteMessage(orderMessage: OrderMessage) {
    this.orderMessageService.deleteOrderMessage(orderMessage.orderID, orderMessage.id).subscribe({
      next: () => {
        this.orderMessages = this.orderMessages.filter((u) => u.id != orderMessage.id);
        this.resetOrderMessages();
      },
      error: () => {

      }
    });
  }

  saveMessage() {
    if (!this.newMessage.message.trim()) {
      return;
    }

    this.isSaving = true;

    this.orderMessageService.createOrderMessage(this.order.id, this.newMessage)
      .subscribe({
        next: result => {
          this.newMessage.message = "";
          this.orderMessages.push(result);
          this.resetOrderMessages();
          this.isSaving = false;
        },
        error: () => {
          this.isSaving = false;
        }
      });
  }

  private resetOrderMessages() {
    this.order.orderMessages = this.orderMessages;
    this.dataSource.data = this.orderMessages;
  }
}